import { useQuery } from '@tanstack/react-query';
import { useNostr } from '@nostrify/react';
import type { NostrEvent } from '@nostrify/nostrify';

// Big relays with good hashtag coverage
const BIG_RELAY_URLS = [
  'wss://relay.damus.io/',
  'wss://nos.lol/',
  'wss://relay.nostr.band/',
  'wss://nostr.mom/',
];

/**
 * Hook to search for notes by hashtag
 */
export function useHashtagSearch(hashtag: string, enabled = true) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['hashtag-search', hashtag],
    queryFn: async (c): Promise<NostrEvent[]> => {
      if (!hashtag.trim()) return [];

      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(1500)]);

      try {
        const bigRelays = nostr.group(BIG_RELAY_URLS);
        const events = await bigRelays.query(
          [
            {
              kinds: [1], // Short text notes
              '#t': [hashtag.toLowerCase()],
              limit: 20,
            },
          ],
          { signal }
        );

        return events;
      } catch (error) {
        console.error('Hashtag search failed:', error);
        return [];
      }
    },
    enabled: enabled && !!hashtag.trim(),
    staleTime: 30000, // 30 seconds
    gcTime: 300000, // Keep in cache for 5 minutes
    placeholderData: (previousData) => previousData, // Show previous results while loading
  });
}
